<h1>Search results</h1>
<ee-help-search [query]="query" (openArticle)="openArticle($event)"></ee-help-search>
